module.exports = __webpack_public_path__ + "static/media/DragZoneImage.68b5c5b4.svg";